export default [
    {
        path: '/dashboard',
        component: () => import(/* webpackChunkName: "js/customer" */ './views/customers/dashboard/dashboard-show.vue'),
        meta: {
            public: false,
        },
    },

    // di linx
    {
        path: '/di-linx',
        component: () => import(/* webpackChunkName: "js/customer" */ './views/customers/di-linx/di-linx-index.vue'),
        meta: {
            roles: ['customer_di_linx'],
            includeInMenu: true,
            title: 'DI Linx',
        },
    },
    {
        path: '/di-linx/:di_linx_id',
        component: () => import(/* webpackChunkName: "js/customer" */ '@views/customers/di-linx/di-linx-show.vue'),
        meta: {
            roles: ['customer_di_linx'],
        },
    },

    // water linx
    {
        path: '/water-linx',
        component: () => import(/* webpackChunkName: "js/customer" */ './views/customers/water-linx/water-linx-index.vue'),
        meta: {
            roles: ['customer_water_linx'],
            includeInMenu: true,
            title: 'Water Linx',
        },
    },
    {
        path: '/water-linx/:water_linx_id',
        redirect: '/water-linx/:water_linx_id/dashboard',
    },
    {
        path: '/water-linx/:water_linx_id/dashboard',
        component: () => import(/* webpackChunkName: "js/customer" */ '@views/customers/water-linx/water-linx-dashboard-show.vue'),
        meta: {
            roles: ['customer_water_linx'],
        },
    },
    {
        path: '/water-linx/:water_linx_id/history',
        component: () => import(/* webpackChunkName: "js/customer" */ '@views/customers/water-linx/history/water-linx-history-index.vue'),
        meta: {
            roles: ['customer_water_linx'],
        },
    },

    // di trailers
    {
        path: '/di-trailers',
        component: () => import(/* webpackChunkName: "js/customer" */ './views/customers/di-trailers/di-trailer-index.vue'),
        meta: {
            roles: ['customer_di_trailers'],
            includeInMenu: true,
            title: 'DI Trailers',
        },
    },
    {
        path: '/di-trailer-locations/:location_id',
        component: () => import(/* webpackChunkName: "js/customer" */ '@views/customers/di-trailers/di-trailer-location-show.vue'),
        meta: {
            roles: ['customer_di_trailers'],
        },
    },

    {
        // Vue Router 4 wildcard syntax (was '*' in v3).
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import(/* webpackChunkName: "js/customer" */ './views/system/404.vue'),
        meta: {
            public: true,
        },
    },
];
